export default __webpack_public_path__ + "static/media/KOD0000-min.b0eb2c9e.webp";